module.exports = __webpack_public_path__ + "img/mission-diversity-banner2.jpg?d4d7f177ded5ee65a1d40cda6078f3f5";